import { useStaticQuery, graphql } from 'gatsby';

export const useCommonSectionData = () => {
  const data = useStaticQuery(graphql`
    query {
      commonSectionPageDataJson {
        suitability {
          button_text
          button_to
          caption
          description
          headline
        }
        solution_process {
          button_text
          button_to
          description {
            html
          }
          headline {
            html
          }
        }
      }
    }
  `);

  return data.commonSectionPageDataJson;
};
